package pt.at.oss.kotlin.manual.schema.common

import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.ADDRESS_BUILDING_NUMBER_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.ADDRESS_CITY_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.ADDRESS_COUNTRY_SUB_ENTITY_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.ADDRESS_DISTRICT_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.ADDRESS_FLOOR_NUMBER_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.ADDRESS_FREE_TEXT_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.ADDRESS_OTHER_LOCAL_ID_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.ADDRESS_POST_CODE_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.ADDRESS_POST_OFFICE_BOX_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.ADDRESS_STREET_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.ADDRESS_SUITE_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.ISSUING_COUNTRY_LEN
import pt.at.oss.kotlin.manual.storage.common.Address
import pt.lightweightform.kotlin.schema.RecordSchema
import pt.lightweightform.kotlin.schema.StringSchema
import pt.lightweightform.kotlin.type.validator.ValidationErrors
import pt.lightweightform.kotlin.util.appendToPath

/**
 * AddressSchema Schema object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
class AddressSchema : RecordSchema<Address>(name = "address") {

    val typeSchema: StringSchema = StringSchema(name = "type", isRequired = true)
    val streetSchema: StringSchema = StringSchema(name = "street", maxLength = ADDRESS_STREET_MAX_LEN)
    val buildingNumberSchema: StringSchema = StringSchema(name = "buildingNumber", maxLength = ADDRESS_BUILDING_NUMBER_MAX_LEN)
    val floorNumberSchema: StringSchema = StringSchema(name = "floorNumber", maxLength = ADDRESS_FLOOR_NUMBER_MAX_LEN)
    val postCodeSchema: StringSchema = StringSchema(name = "postCode", maxLength = ADDRESS_POST_CODE_MAX_LEN)
    val citySchema: StringSchema = StringSchema(name = "city", maxLength = ADDRESS_CITY_MAX_LEN)
    val countrySchema: StringSchema = StringSchema(name = "country", isRequired = true, minLength = ISSUING_COUNTRY_LEN, maxLength = ISSUING_COUNTRY_LEN)
    val regionSchema: StringSchema = StringSchema(name = "region", isRequired = false, minLength = ISSUING_COUNTRY_LEN, maxLength = ISSUING_COUNTRY_LEN)
    val suiteSchema: StringSchema = StringSchema(name = "suite", maxLength = ADDRESS_SUITE_MAX_LEN)
    val districtSchema: StringSchema = StringSchema(name = "district", maxLength = ADDRESS_DISTRICT_MAX_LEN)
    val postOfficeBoxSchema: StringSchema = StringSchema(name = "postOfficeBox", maxLength = ADDRESS_POST_OFFICE_BOX_MAX_LEN)
    val countrySubEntitySchema: StringSchema = StringSchema(name = "countrySubEntity", maxLength = ADDRESS_COUNTRY_SUB_ENTITY_MAX_LEN)
    val otherLocalIdSchema: StringSchema = StringSchema(name = "otherLocalId", maxLength = ADDRESS_OTHER_LOCAL_ID_MAX_LEN)
    val freeTextSchema: StringSchema = StringSchema(name = "freeText", maxLength = ADDRESS_FREE_TEXT_MAX_LEN)
    override fun isValid(value: Address?): Boolean {
        return value == null || (
            typeSchema.isValid(value.type) &&
                streetSchema.isValid(value.street) &&
                buildingNumberSchema.isValid(value.buildingNumber) &&
                floorNumberSchema.isValid(value.floorNumber) &&
                postCodeSchema.isValid(value.postCode) &&
                citySchema.isValid(value.city) &&
                countrySchema.isValid(value.country) &&
                regionSchema.isValid(value.region) &&
                suiteSchema.isValid(value.suite) &&
                districtSchema.isValid(value.district) &&
                postOfficeBoxSchema.isValid(value.postOfficeBox) &&
                countrySubEntitySchema.isValid(value.countrySubEntity) &&
                otherLocalIdSchema.isValid(value.otherLocalId) &&
                freeTextSchema.isValid(value.freeText)
            )
    }

    override fun validate(value: Address?, path: String): ValidationErrors {
        val validator = super.validate(value, path)
        if (value === null) {
            return validator
        }
        validator.addErrors(typeSchema.validate(value.type, appendToPath(path, "type")))
        validator.addErrors(streetSchema.validate(value.street, appendToPath(path, "street")))
        validator.addErrors(buildingNumberSchema.validate(value.buildingNumber, appendToPath(path, "buildingNumber")))
        validator.addErrors(floorNumberSchema.validate(value.floorNumber, appendToPath(path, "floorNumber")))
        validator.addErrors(postCodeSchema.validate(value.postCode, appendToPath(path, "postCode")))
        validator.addErrors(citySchema.validate(value.city, appendToPath(path, "city")))
        validator.addErrors(countrySchema.validate(value.country, appendToPath(path, "country")))
        validator.addErrors(regionSchema.validate(value.region, appendToPath(path, "region")))
        validator.addErrors(suiteSchema.validate(value.suite, appendToPath(path, "suite")))
        validator.addErrors(districtSchema.validate(value.district, appendToPath(path, "district")))
        validator.addErrors(postOfficeBoxSchema.validate(value.postOfficeBox, appendToPath(path, "postOfficeBox")))
        validator.addErrors(countrySubEntitySchema.validate(value.countrySubEntity, appendToPath(path, "countrySubEntity")))
        validator.addErrors(otherLocalIdSchema.validate(value.otherLocalId, appendToPath(path, "otherLocalId")))
        validator.addErrors(freeTextSchema.validate(value.freeText, appendToPath(path, "freeText")))
        return validator
    }
}
